import type { ExcelColumnDef } from "@/lib/excel.utils";

/**
 * Cột Excel danh mục sản phẩm — một định nghĩa cho xuất, file mẫu và nhập (04/11/2026).
 * Nhập qua bảng duyệt (SmartImportStagingModal): khách hàng, loại SP, vật tư chọn / bổ sung ở bước duyệt,
 * nên Mã KH, Loại SP, Quy cách đóng gói chỉ xuất (importable: false).
 */
export const PRODUCT_EXCEL_COLUMNS: ExcelColumnDef[] = [
  { key: "productCode", label: "Mã SP" },
  { key: "productName", label: "Tên SP", required: true },
  { key: "unit", label: "Đơn vị", required: true },
  { key: "price", label: "Giá bán", type: "decimal", min: 0, numFmt: "#,##0.##" },
  { key: "costPrice", label: "Giá vốn", type: "decimal", min: 0, numFmt: "#,##0.##" },
  { key: "notes", label: "Ghi chú" },
  { key: "customer.code", label: "Mã KH", importable: false },
  { key: "productType.code", label: "Loại SP", importable: false },
  { key: "packingSpec", label: "Quy cách đóng gói", importable: false },
];

/** Đọc một dòng file (tiêu đề theo PRODUCT_EXCEL_COLUMNS; nhận cả tiêu đề cũ) → dòng gửi bước duyệt */
export function productRowFromExcel(row: Record<string, string>) {
  const pick = (...keys: string[]) => {
    for (const k of keys) if (row[k] !== undefined && String(row[k]).trim() !== "") return String(row[k]).trim();
    return "";
  };
  const num = (v: string) => {
    if (!v) return undefined;
    const n = parseFloat(v.replace(/,/g, ""));
    return Number.isFinite(n) ? n : undefined;
  };
  return {
    productCode: pick("Mã SP", "productCode", "code"),
    productName: pick("Tên SP", "productName", "name"),
    specs: pick("Quy cách", "specs"),
    unit: pick("Đơn vị", "unit"),
    quantity: parseInt(pick("Số lượng", "quantity") || "0", 10) || 0,
    unitPrice: num(pick("Giá bán", "price", "unitPrice")) ?? 0,
    costPrice: num(pick("Giá vốn", "costPrice")),
    notes: pick("Ghi chú", "notes"),
  };
}
